export default "__VITE_ASSET__VMtscmLZ__"